
import React from "react";
import { PartCategory, PartFilter, PartSubcategory } from "@/data/parts";
import FilterSidebarHeader from "@/components/sidebar/SidebarHeader";
import CategoryMenu from "@/components/sidebar/CategoryMenu";
import SpecialFiltersGroup from "@/components/sidebar/SpecialFiltersGroup";
import RatingSlider from "@/components/sidebar/RatingSlider";
import { useIsMobile } from "@/hooks/use-mobile";

interface FilterSidebarProps {
  selectedCategory: PartCategory | "all";
  setSelectedCategory: (category: PartCategory | "all") => void;
  selectedSubcategory: PartSubcategory | "all";
  setSelectedSubcategory: (subcategory: PartSubcategory | "all") => void;
  activeFilters: PartFilter[];
  toggleFilter: (filter: PartFilter) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  totalPartsCount?: number;
  minStarRating?: number;
  setMinStarRating?: (rating: number) => void;
}

const FilterSidebar = ({
  selectedCategory,
  setSelectedCategory,
  selectedSubcategory,
  setSelectedSubcategory,
  activeFilters,
  toggleFilter,
  searchQuery,
  setSearchQuery,
  totalPartsCount = 0,
  minStarRating = 0,
  setMinStarRating
}: FilterSidebarProps) => {
  // Determine if we're in the Parts page by checking if both minStarRating and setMinStarRating are provided
  const isPartsPage = minStarRating !== undefined && setMinStarRating !== undefined;
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-col h-full bg-card border-r border-border overflow-y-auto">
      <FilterSidebarHeader 
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        totalPartsCount={totalPartsCount}
      />
      
      <div className="flex-1 overflow-auto p-2">
        {/* Printer Model Group with nested subcategories */}
        <CategoryMenu
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedSubcategory={selectedSubcategory}
          setSelectedSubcategory={setSelectedSubcategory}
        />
        
        {/* Special Filters Group */}
        <SpecialFiltersGroup
          activeFilters={activeFilters}
          toggleFilter={toggleFilter}
          selectedSubcategory={selectedSubcategory}
        />
      </div>
      
      {/* Rating Slider - Only shown on Parts page */}
      {isPartsPage && setMinStarRating && (
        <RatingSlider
          minStarRating={minStarRating}
          setMinStarRating={setMinStarRating}
        />
      )}
    </div>
  );
};

export default FilterSidebar;
